import dayjs from 'dayjs';

export const filterValidDate = (date: string) => {
  if (Number(dayjs(date).format('YYYY')) < 2023) return '';
  return date;
};

export const daysSince = (timestamp: number | string): number => {
  const now = dayjs();
  const target = dayjs(timestamp);
  return Math.floor(target.diff(now, 'day', true)) || 0;
};
